import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../../shared/shared.module';
import {MatDividerModule} from '@angular/material/divider';
import {MatDialogModule} from '@angular/material/dialog';
import {AdditionalCapabilityComponent} from './additional-capability.component';
import {IconsModule} from '../../icons/icons.module';


@NgModule({
  declarations: [AdditionalCapabilityComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatDividerModule,
    MatDialogModule,
    IconsModule
  ]
})
export class AdditionalCapabilityModule {
}

